import { ComponentProps, useId } from "react";
import { Helptext } from "./helptext";
import { Input } from "./input";
import { Label } from "./label";

type InputfieldProps = ComponentProps<"input"> & {
    label: string;
    value: string;
    onValueChange: (value: string) => void;
    optional?: boolean;
    helptext?: string;
};

// simple inputfield, useful if a RHF inputfield is not necessary
export function Inputfield({ label, value, onValueChange, optional = false, helptext, ...props }: InputfieldProps) {
    const id = useId();
    return (
        <div className="grid gap-1">
            <Label htmlFor={id} optional={optional}>
                {label}
            </Label>
            <Input id={id} value={value} onChange={(e) => onValueChange(e.target.value)} {...props} />
            {helptext && <Helptext>{helptext}</Helptext>}
        </div>
    );
}
